import React from 'react';
import { Modal, Offcanvas, Button } from 'react-bootstrap';
import useIsMobile from './useIsMobile';
import './SuccessModal.css';
import { useNavigate } from 'react-router-dom';
import paymentLoading from '../assets/WalletAnimation.json';
import Lottie from 'lottie-react';

const PaymentLoading = ({ show, onClose }) => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();

  const handleRedirect = () => {
    onClose(); // Close modal first
    navigate('/'); // Navigate to bookings page
  };

  const Content = () => (
    <>
        <div className="lottie-wrapper mb-2" style={{ width: 220 }}>
        <Lottie animationData={paymentLoading} loop={false}  />
      </div>
      <h4 className="mt-3">Secure Payment Processing!</h4>
      <p>Do not close this window. We’ll confirm your booking shortly.</p>
      {/* <Button className="btn-own mt-2" onClick={handleRedirect}>
        Go to My Bookings
      </Button> */}
    </>
  );

  return isMobile ? (
    <Offcanvas
      show={show}
      onHide={onClose}
      placement="bottom"
      backdrop={true}
      style={{ height: 'auto', borderRadius: '30px 30px 0 0', borderColor: '#0c609c' }}
    >
      <Offcanvas.Body className="d-flex flex-column justify-content-center align-items-center text-center"
        style={{ padding: '30px', minHeight: '100%' }}>
        <Content />
      </Offcanvas.Body>
    </Offcanvas>
  ) : (
    <Modal show={show} onHide={onClose} centered backdrop="static" style={{borderRadius:'30px'}}>
      <Modal.Body className="text-center">
        <center>
        <Content />
        </center>
      </Modal.Body>
    </Modal>
  );
};

export default PaymentLoading;
